var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"จัดโปรโมชั่นราคาใหม่","link_back":"promotioninformation"}}),_c('Promotion_add_pos_price')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }